import React from 'react';
import { Box } from '@mui/material';
import { Cursor, Page } from '@qualifio/api-client';
import { QlfPaginationFooter } from '@qualifio/ui-commons/dist/components/qlf-master-detail';
import { LazyCounter } from './LazyCounter';

interface Props {
  changePage: (pageNumber: number) => void;
  dataPage: Cursor<any> | Page<any> | undefined;
  currentPage: number;
  pageSize?: number;
  isLoading: boolean;
  getCount?: () => Promise<number>;
  filters?: any;
}

export function PaginationFooter({
  changePage,
  dataPage,
  currentPage,
  pageSize = 10,
  isLoading,
  getCount,
  filters,
}: Props): React.ReactElement {
  return (
    <Box sx={{ position: 'relative' }}>
      {/*TODO workaround until QlfPaginationFooter from ui-commons features position display*/}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {dataPage?.type === 'page' ? (
          `${currentPage + 1}/${dataPage.pageCount || 1}`
        ) : (
          <>
            {getCount && (
              <LazyCounter
                getCount={getCount}
                pageNumber={currentPage}
                pageSize={pageSize}
                filters={filters}
              />
            )}
          </>
        )}
      </Box>
      <QlfPaginationFooter
        onPrevious={() => changePage(-1)}
        onNext={() => changePage(1)}
        disablePrevious={
          currentPage === 0 ||
          (dataPage?.type === 'page' && typeof dataPage?.previousPage !== 'number') ||
          (dataPage?.type === 'cursor' && !dataPage?.previous) ||
          isLoading
        }
        disableNext={
          !dataPage?.data ||
          (dataPage?.type === 'page' && typeof dataPage?.nextPage !== 'number') ||
          (dataPage?.type === 'cursor' && !dataPage?.next) ||
          isLoading
        }
      />
    </Box>
  );
}
